


import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ApiCallService from "../../Service/ApiCallService";
import Spinner from "../common/Spinner";
import { message, Modal } from "antd";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

import {
  IconButton,
  Menu,
  MenuItem,
  Button,
  Paper,
  Divider,
  Typography,
} from "@mui/material";

import {
  FaTrash,
  FaUsers,
  FaGlobe,
  FaStar,
  FaHandsHelping,
} from "react-icons/fa";

import InputField from "../common/InputField";
import theme from "../../theme/themeConfig";

import StarterKit from "@tiptap/starter-kit";
import {
  RichTextEditor,
  MenuControlsContainer,

  MenuButtonBold,
  MenuButtonItalic,
  MenuButtonUnderline,
  MenuButtonStrikethrough,

  MenuButtonBulletedList,
  MenuButtonOrderedList,

  MenuButtonBlockquote,

  MenuButtonUndo,
  MenuButtonRedo,

  MenuButtonEditLink,

  MenuSelectHeading,

  MenuButtonAlignLeft,
  MenuButtonAlignCenter,
  MenuButtonAlignRight,
  MenuButtonAlignJustify,

  MenuButtonRemoveFormatting,
} from "mui-tiptap";

import DOMPurify from "dompurify";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import {useMediaQuery, useTheme} from "@mui/material" 
const MAX_WORDS = 100;


const extensions = [
  StarterKit,
  Underline,
  Link,
  TextAlign.configure({
    types: ["heading", "paragraph"],
  }),
];

const getFileType = (url) => {
  if (url?.match(/\.(jpg|jpeg|png|gif)$/i)) return "image";
  if (url?.match(/\.(mp4|webm|ogg)$/i)) return "video";
  if (url?.match(/\.(mp3|wav)$/i)) return "audio";
  return "document";
};

const stripHtml = (html = "") => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const countWords = (text = "") => {
  const plainText = stripHtml(text);
  return plainText.trim() ? plainText.trim().split(/\s+/).length : 0;
};

const JourneyDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const loggedInUserId = localStorage.getItem("userId");

  const queryParams = new URLSearchParams(location.search);

  const targetUserId =
    location.state?.userId ||
    location.state?.profileUserId ||
    queryParams.get("userId") ||
    loggedInUserId;

  const [journey, setJourney] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const S3URL = "https://vmsprojectdata.s3.ap-south-1.amazonaws.com/";

  const positionOptions = [
    {
      label: "National President",
      value: "National President",
      icon: <FaStar />,
    },
    {
      label: "State President",
      value: "State President",
      icon: <FaGlobe />,
    },
    {
      label: "Chapter President",
      value: "Chapter President",
      icon: <FaUsers />,
    },
    {
      label: "Volunteer",
      value: "Volunteer",
      icon: <FaHandsHelping />,
    },
  ];

  useEffect(() => {
    const fetchJourney = async () => {
      try {
        setLoading(true);

        const res = await ApiCallService.get(
          `${process.env.REACT_APP_BASE_URL}/${targetUserId}/journey/${id}`
        );

        setJourney({
          ...res,
          description: res.description || "",
          documents: res.documents.map((url) => ({
            url,
            type: getFileType(url),
          })),
        });
      } catch {
        message.error("Failed to load journey");
      } finally {
        setLoading(false);
      }
    };

    fetchJourney();
  }, [id, targetUserId]);

  const handleDescriptionChange = (htmlValue) => {
    setJourney({
      ...journey,
      description: htmlValue,
    });
  };

  const handleDeleteJourney = () => {
    setMenuAnchor(null);

    Modal.confirm({
      centered: true,
      icon: null,
      closable: true,
      closeIcon: <CloseIcon sx={{ color: "red" }} />,
      title: (
        <div className="text-center text-lg font-semibold text-red-600">
          Delete Journey
        </div>
      ),
      content: (
        <p className="text-center text-gray-600 mt-2">
          This action cannot be undone.
        </p>
      ),
      okText: "Delete Journey",
      okButtonProps: {
        style: { backgroundColor: theme.palette.error.main },
      },
      cancelButtonProps: { style: { display: "none" } },
      onOk: async () => {
        try {
          setLoading(true);

          await ApiCallService.delete(
            `${process.env.REACT_APP_BASE_URL}/${targetUserId}/journey/${id}`
          );

          message.success("Journey deleted successfully");
          navigate(-1);
        } catch {
          message.error("Delete failed");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleUpdate = async () => {
    if (countWords(journey.description) > MAX_WORDS) {
      message.error(`Description cannot exceed ${MAX_WORDS} words`);
      return;
    }

    if (
      journey.endDate &&
      journey.startDate &&
      journey.endDate < journey.startDate
    ) {
      message.error("End date cannot be before start date");
      return;
    }

    setLoading(true);

    try {
      const uploadedUrls = [];

      for (const doc of journey.documents) {
        if (doc.isNew && doc.file) {
          const fd = new FormData();
          fd.append("file", doc.file);

          const res = await ApiCallService.post(
            `${process.env.REACT_APP_BASE_URL}/upload/document/image`,
            fd
          );

          uploadedUrls.push(res.s3Key);
        } else if (doc.url) {
          uploadedUrls.push(doc.url);
        }
      }

      const res = await ApiCallService.put(
        `${process.env.REACT_APP_BASE_URL}/${targetUserId}/journey/${id}`,
        {
          ...journey,
          documents: uploadedUrls,
        }
      );

      message.success(res?.message || "Journey updated successfully");
      setEditMode(false);
      navigate(-1);
    } catch {
      message.error("Update failed");
    } finally {
      setLoading(false);
    }
  };

  const isSixMonthsGap = (start, end) => {
    if (!start || !end) return true;

    const startDate = new Date(start);
    const endDate = new Date(end);

    const minEndDate = new Date(startDate);
    minEndDate.setMonth(minEndDate.getMonth() + 6);

    return endDate >= minEndDate;
  };

  const descriptionWordCount = countWords(journey?.description);
  const hasDescriptionWordLimitError = descriptionWordCount > MAX_WORDS;

  if (loading) return <Spinner loading />;

  return (
    <div className="min-h-screen bg-white-50 py-6">
      <Paper className="max-w-5xl mx-auto rounded-xl" sx={{p: {xs:3, md:4} }}>
        {/* HEADER */}
        <div className="flex justify-between items-center mb-4">
          <Button sx={{display:"flex", flexDirection:"row", gap:1}} variant="outlined" onClick={() => navigate(-1)}>
            <ArrowBackIcon /> {!isMobile && "Back"}
          </Button>

          <Typography
          sx={{
            fontWeight:700,
            fontSize: {
              xs: "1.5rem", // h5-ish
              sm: "1.825rem", // h4-ish
              md: "2.05rem", // h4-ish
            }
          }}>Journey Details</Typography>

          <IconButton onClick={(e) => setMenuAnchor(e.currentTarget)}>
            <MoreVertIcon />
          </IconButton>
        </div>

        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={() => setMenuAnchor(null)}
        >
          <MenuItem
            onClick={() => {
              setEditMode(true);
              setMenuAnchor(null);
            }}
          >
            Edit
          </MenuItem>

          <MenuItem onClick={handleDeleteJourney} sx={{ color: "red" }}>
            Delete
          </MenuItem>
        </Menu>

        {/* FORM */}
        <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-4">
          <InputField
            type="text"
            label="Position / Role"
            value={journey.position}
          //  options={positionOptions}
            disabled={!editMode}
            onChange={(v) => setJourney({ ...journey, position: v })}
          />

          <InputField
            type="date"
            label="Start Date"
            value={journey.startDate}
            disabled={!editMode}
            onChange={(v) => {
              if (journey.endDate && !isSixMonthsGap(v, journey.endDate)) {
                message.error(
                  "End date must be at least 6 months after start date"
                );
                return;
              }

              setJourney({ ...journey, startDate: v });
            }}
          />

          <InputField
            type="date"
            label="End Date"
            value={journey.endDate}
            disabled={!editMode}
            onChange={(v) => {
              if (journey.startDate && !isSixMonthsGap(journey.startDate, v)) {
                message.error(
                  "End date must be at least 6 months after start date"
                );
                return;
              }

              setJourney({ ...journey, endDate: v });
            }}
          />
        </div>

        {/* DESCRIPTION FULL WIDTH */}
        <div>
          <label
            className={`block mb-2 font-medium ${
              hasDescriptionWordLimitError ? "text-red-600" : ""
            }`}
          >
            Description ({descriptionWordCount}/{MAX_WORDS} words)
          </label>

          {editMode ? (
            <div className="border rounded-md overflow-hidden">
          <RichTextEditor
  content={journey.description || ""}
  extensions={extensions}
  onUpdate={({ editor }) =>
    handleDescriptionChange(editor.getHTML())
  }
  renderControls={() => (
    <MenuControlsContainer>
      <MenuSelectHeading />

      <MenuButtonBold />
      <MenuButtonItalic />
      <MenuButtonUnderline />
      <MenuButtonStrikethrough />

      <MenuButtonBulletedList />
      <MenuButtonOrderedList />

      <MenuButtonAlignLeft />
      <MenuButtonAlignCenter />
      <MenuButtonAlignRight />
      <MenuButtonAlignJustify />

      <MenuButtonBlockquote />

      <MenuButtonEditLink />

      <MenuButtonUndo />
      <MenuButtonRedo />

      <MenuButtonRemoveFormatting />
    </MenuControlsContainer>
  )}
/>
            </div>
          ) : (
            <div
              className="border rounded-md p-3 min-h-[180px] prose max-w-none"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(journey.description || ""),
              }}
            />
          )}
        </div>

        <Divider className="my-5" />

        {/* DOCUMENTS */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {journey.documents.map((doc, i) => (
            <div
              key={i}
              className="relative border rounded-lg p-2"
              style={{ minWidth: "50px" }}
            >
              {editMode && (
                <FaTrash
                  className="absolute top-2 right-2 text-red-500 cursor-pointer"
                  onClick={() => {
                    const updated = [...journey.documents];
                    updated.splice(i, 1);
                    setJourney({ ...journey, documents: updated });
                  }}
                />
              )}

              {doc.type === "image" && (
                <img
                  src={`${S3URL}${doc.url}` || URL.createObjectURL(doc.file)}
                  alt=""
                />
              )}

              {doc.type === "video" && (
                <video
                  src={`${S3URL}${doc.url}` || URL.createObjectURL(doc.file)}
                  controls
                />
              )}

              {doc.type === "audio" && (
                <audio
                  src={`${S3URL}${doc.url}` || URL.createObjectURL(doc.file)}
                  controls
                />
              )}

              {doc.type === "document" && (
                <embed
                  src={
                    `${S3URL}${doc.url}#toolbar=0` ||
                    URL.createObjectURL(doc.file)
                  }
                  type="application/pdf"
                  width="100%"
                  height="100%"
                />
              )}
            </div>
          ))}
        </div>

        {editMode && (
          <div className="mt-6 text-right">
            <Button
              variant="contained"
              onClick={handleUpdate}
              disabled={hasDescriptionWordLimitError || loading}
            >
              Update Journey
            </Button>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default JourneyDetailPage;